import { AnimatePresence, motion } from "framer-motion";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { PlayIconOutline } from "components/icons/PlayIconOutline";
import { ProductTourPoster } from "components/icons/ProductTourPoster";
import {
  PLATFORM_TOUR_LAYOUT_DURATION_S,
  PLATFORM_TOUR_LAYOUT_ID,
  PLATFORM_TOUR_LAYOUT_TRANSITION,
} from "constants/productTour";

type PlatformTourWelcomeModalProps = {
  open: boolean;
  onWatch: () => void;
  onSkip: () => void;
};

export const PlatformTourWelcomeModal = ({
  open,
  onWatch,
  onSkip,
}: PlatformTourWelcomeModalProps) => {
  const handleDismissAttempt = (event: Event) => {
    event.preventDefault();
    onSkip();
  };

  const preventFocusRestore = (event: Event) => event.preventDefault();
  const preventFocusSkip = (event: Event) => event.preventDefault();

  return (
    <AnimatePresence>
      {open && (
        <Modal.Root open>
          <Modal.Portal forceMount>
            <Modal.Overlay asChild forceMount>
              <motion.div
                exit={{
                  opacity: 0,
                  transition: {
                    duration: PLATFORM_TOUR_LAYOUT_DURATION_S * 0.5,
                  },
                }}
              />
            </Modal.Overlay>
            <Modal.RawContent
              asChild
              forceMount
              aria-describedby={undefined}
              onEscapeKeyDown={handleDismissAttempt}
              onPointerDownOutside={handleDismissAttempt}
              onFocusOutside={preventFocusSkip}
              onCloseAutoFocus={preventFocusRestore}
            >
              <motion.div
                exit={{ opacity: 0, transition: { duration: 0.2 } }}
                style={{ borderRadius: 12 }}
                className="t-fixed t-inset-0 t-z-modal t-m-auto t-flex t-h-fit t-w-[560px] t-max-w-[90vw] t-flex-col t-overflow-hidden t-border t-border-solid t-border-neutral-0 t-bg-white t-shadow-2xl"
              >
                <motion.div
                  layoutId={PLATFORM_TOUR_LAYOUT_ID.MEDIA}
                  layoutCrossfade={false}
                  transition={PLATFORM_TOUR_LAYOUT_TRANSITION}
                  className="t-overflow-hidden"
                >
                  <ProductTourPoster />
                </motion.div>
                <div className="t-flex t-flex-col t-bg-white t-p-8">
                  <Modal.Title className="t-text-title-h3-bold t-text-text-100">
                    Welcome to Inkle! 🎉
                  </Modal.Title>
                  <span className="t-text-body t-text-text-30 t-mt-1">
                    Not sure where to start? Take a quick tour to see how Inkle
                    Tax works, from sharing your information to getting your
                    filings taken care of.
                  </span>

                  <div className="t-mt-6 t-flex t-items-center t-gap-3">
                    <Button
                      customType="primary"
                      onClick={onWatch}
                      leftIcon={<PlayIconOutline />}
                    >
                      Watch now
                    </Button>
                    <Button customType="ghost" onClick={onSkip}>
                      Maybe later
                    </Button>
                  </div>
                </div>
              </motion.div>
            </Modal.RawContent>
          </Modal.Portal>
        </Modal.Root>
      )}
    </AnimatePresence>
  );
};
